import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AccountInfo } from '@azure/msal-browser';
import { HttpClient } from '@angular/common/http';
import { User } from 'app/modules/shared/model/user';
import { ApplicationService } from 'app/app-services/application.service';
import { AuthService } from 'app/modules/authentication/services/auth.service';

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.css']
})
export class ShellComponent implements OnInit {
  showNavbar = true;
  title = 'app';
  loaded = false;
  showBrowserWarning = true;
  subscriptions: Subscription[] = [];
  private readonly rolePriority: { [key: string]: number } = {
  'basic': 1,
  'reader': 1,
  'AP3698001-dcode-prod-basic': 1,
  'AP3698001-CN-Reader': 1,

  'extended': 2,
  'collaborator': 2,
  'AP3698001-dcode-prod-extended': 2,

  'complete': 3,
  'system-owner': 3,
  'AP3698001-dcode-prod-complete': 3,
  'AP3698001-CN-SystemOwner': 3,

  'advanced': 4,
  'rbacc-approver': 4,
  'AP3698001-dcode-prod-advanced': 4,

  'admin': 5,
  'AP3698001-dcode-prod-admin': 5,
  };

  loginDisplay: boolean;
  profile: any;
  currentUser: User;
  public jwtToken: string = "";
  public currentUserRoles: any = [];
  username: string;
  userRole: string;

  constructor(private appService: ApplicationService,
    protected http: HttpClient,
    private authService: AuthService
  ) {
    this.loaded = true;
  }
  ngOnInit(): void {
    this.subscriptions.push(this.appService.requestFullScreen.subscribe(arg => {
      this.showNavbar = false;
    }));

    this.subscriptions.push(this.appService.requestNormalWindowMode.subscribe(arg => {
      this.showNavbar = true;
    }));

    const msalInstance = this.authService.currentMsalService.instance;
    const accountInfo: AccountInfo | null = msalInstance.getActiveAccount();

    if (accountInfo) {
      this.username = accountInfo.name ?? 'User Name';
      this.userRole = this.getUserRole(accountInfo.idTokenClaims?.roles ?? []);
      this.userRole == null ? localStorage.setItem("currentUserRole", "null") : localStorage.setItem("currentUserRole", this.userRole);
    }
  }

  public getUserRole(roles: string[]): string {
    this.currentUserRoles = roles;
    return this.getHighestRole(this.currentUserRoles)
  }

  public getHighestRole(roles: string[]): string | null {
    const roleMappings: Record<string, string> = {
      'admin': 'Admin',
      'AP3698001-dcode-prod-admin': 'Admin',

      'advanced': 'Advanced',
      'rbacc-approver': 'Advanced',
      'AP3698001-dcode-prod-advanced': 'Advanced',

      'complete': 'System Owner',
      'system-owner': 'System Owner',
      'AP3698001-dcode-prod-complete': 'System Owner',
      'AP3698001-CN-SystemOwner': 'System Owner',

      'extended': 'Collaborator',
      'collaborator': 'Collaborator',
      'AP3698001-dcode-prod-extended': 'Collaborator',

      'basic': 'Reader',
      'reader': 'Reader',
      'AP3698001-dcode-prod-basic': 'Reader',
      'AP3698001-CN-Reader': 'Reader',
    };

    if (!roles?.length) return null;
    let highestRoleKey: string | null = null;
    for (const role of roles) {      
      if (
        !highestRoleKey ||
        this.rolePriority[role] > this.rolePriority[highestRoleKey]
      ) {
        highestRoleKey = role;
      }
    }
    return highestRoleKey ? (roleMappings[highestRoleKey] ?? null) : null;
  }

  closeBrowserWarning(): void {
    this.showBrowserWarning = false;
  }
}
